import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=50fc6d74&scoped=true"
import script from "./Clubs.vue?vue&type=script&lang=js"
export * from "./Clubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc6d74",
  null
  
)

export default component.exports